import { useAtomValue } from 'jotai'
import useSmartAccount from 'src/common/api-clients/safe-protocol-kit/useSmartAccount'
import useApprovalStatus from 'src/common/contracts/hooks/token/useApprovalStatus'
import useConfig from 'src/config/hooks/useConfig'
import { viccCountAtom } from '../../bundle-store'
import useCarbon from 'src/common/queries/useCarbon'

const useCarbonBundleApproval = () => {
  const { carbon } = useCarbon()
  const burnValue = useAtomValue(viccCountAtom)

  const { contractsAddresses } = useConfig()
  const { smartAccountInfo } = useSmartAccount()

  const {
    approveTokenTx,
    needsApproval,
    refetchAllowance,
    loading: approvalLoading,
  } = useApprovalStatus({
    owner: smartAccountInfo?.address,
    spender: contractsAddresses.carbonBundleAddress,
    amountToSpend: burnValue,
    token: carbon || undefined,
  })

  const loading = approvalLoading

  return {
    needsApproval,
    refetchAllowance,
    loading,
    approveCarbon: approveTokenTx,
  }
}

export default useCarbonBundleApproval
